import React from 'react';
import {useHistory, useParams} from 'react-router-dom'
import {Button, Typography} from "antd";
import PropTypes from 'prop-types';
import './application.scss';
import ApplicationDetailTemplate from "../../components/applicationDetailTemplate/applicationDetailTemplate";

import {submit} from "../../apis/application";
import {valueToSubmit} from "../../components/mapToTemplate";
import {replaceUrlByParams} from "../../utils/api";
import {PAGE} from "../../utils/constants";

ApplicationConfirmationPage.propTypes = {
    location: PropTypes.object,
    state: PropTypes.object,
    formValue: PropTypes.object,
    previewValue: PropTypes.object
};

function ApplicationConfirmationPage(props) {
    let formValue, previewValue, history = useHistory()
    const {pid} = useParams()
    const {Title} = Typography

    if(props.location.state) {
        formValue = props.location.state.formValue,
        previewValue = props.location.state.previewValue
    }else{
        history.push(`${replaceUrlByParams(PAGE.LANDING, {':pid':pid})}`)
    }

    function onEdit () {
        history.push({
            pathname: `${replaceUrlByParams(PAGE.APPLICATION, {':pid': pid})}`,
            state: { formValue: formValue }
        });
    }

    const onSubmit = async () => {
        const submitData = valueToSubmit(formValue)
        try {
            let res = await submit(pid, submitData);
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                history.push({
                    pathname: `${replaceUrlByParams(PAGE.APPLICATION_RESULT, {':pid':pid})}`,
                    state: { result: res }
                });

            }
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <>
        { previewValue &&
            (<div className='application-confirmation'>
                <Title className='title' level={3}>確認提交</Title>
                <ApplicationDetailTemplate sections={previewValue} />
                <div className='button-container'>
                    <Button onClick={onEdit}>
                        編輯
                    </Button>
                    <Button type="primary" onClick={onSubmit}>
                        提交
                    </Button>
                </div>

            </div>)
        }
        </>
    )
}

export default ApplicationConfirmationPage;
